import React from 'react';

import { languageController } from '../../../controllers/language/languageController';

import DateAndTimeSelector from '../../3_Organisms/DateAndTimeSelector/DateAndTimeSelector';

interface DateAndTimeData {
  date: Date;
  time: 'morning' | 'afternoon' | 'evening';
}

interface DateAndTimeStepProps {
  handleNextStep: (data: { dateAndTime: DateAndTimeData }) => void;
  title?: string;
  subTitle?: string;
  isService?: boolean;
  handlePreviousStep?: () => void;
}

const DateAndTimeStep: React.FC<DateAndTimeStepProps> = ({
  handleNextStep,
  title = '',
  subTitle = '',
  isService = false,
  handlePreviousStep
}) => {
  return (
    <div className="mz-date-and-time-step">
      <div className="mz-date-and-time-step__top">
        <div className="mz-container">
          <div className="mz-full-width">
            <h5 className="mz-date-and-time-step__title">{title}</h5>
            <p>{subTitle}</p>
            {isService && <p>{languageController.getCopy('bookServiceAppointment', 'notice') || ''}</p>}
          </div>
        </div>
      </div>
      <DateAndTimeSelector 
        onSubmit={(data) => handleNextStep({ dateAndTime: data })} 
        isService={isService} 
        onGoBack={() => handlePreviousStep?.()} 
      />
    </div>
  );
};

export default DateAndTimeStep;
